import { useAppDispatch } from '@verantos-dev/core-annotation-tool';

import { addToAnnotationIdsInEditMode } from '../../../../state/supervisorSlice';

interface UseResolvedCardProps {
  annotationId: string;
}

interface UseResolvedCardResults {
  handleAddToEditMode: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const useResolvedCard = ({ annotationId }: UseResolvedCardProps): UseResolvedCardResults => {
  const dispatch = useAppDispatch();
  const handleAddToEditMode = (e: React.MouseEvent<HTMLButtonElement>) => {
    dispatch(addToAnnotationIdsInEditMode(annotationId));
  };

  return {
    handleAddToEditMode,
  };
};
